export const plural = (message: string, replacements: {[key: string]: string | number}) => {
    return Object.entries(replacements).reduce((translation, [key, value]) => {
        return translation.replace(`{${key}}`, value.toString());
    }, message);
};
